<template>
  <div class="page">
    <div class="page-title">
      客户管理<span style="font-size:0.95rem">/</span><span style="font-weight: bold;font-size:0.95rem">修改</span>
    </div>
    <div class="section-title">
      <div class="sinle-section" v-for="(date,i) in ziLuBy"
           :style="{color:date.isOpt ? '#0f86da' : ''}"
           @click="skip(i)"
      >
        {{ date.text }}
        <div class="sinle-action" v-if="date.isOpt"></div>
      </div>
    </div>
    <div class="content-part">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "customerDetails",
  data() {
    return {
      id: '',
      category:'',
      ziLuBy: [
        {
          path: `basicinfo`,
          isOpt: true,   //第一个默认选中
          text: '客户基本资料'
        },
        {
          path: `relations`,
          isOpt: false,
          text: '客户关系'
        },
        {
          path: `serviceAdvisory`,
          isOpt: false,
          text: '服务咨询'
        },
        {
          path: `unitOne`,
          isOpt: false,
          text: '旅游咨询'
        }
      ],
      CurveUrl: '',
    }
  },
  created() {

    this.initPagStyle()

    //监听游览器后退事件
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.getBack, false)
    }

  },
  destroyed() {
    window.removeEventListener('popstate', this.getBack, false)
  },
  methods: {
    //点击条状路由
    skip(i) {
      this.ziLuBy = this.ziLuBy.map((item, index) => {
        return {
          ...item, isOpt: index === i ? true : false
        }
      })
      const routes = this.ziLuBy[i]
      this.$router.replace(`/index/customers/${routes.path}/${this.id}/${this.category}`)
    },
    getBack() {
      const ids = window.localStorage.getItem("ids")
      if(ids){
         let idSol = JSON.parse(ids)
         const id = idSol[idSol.length - 1]
         if(idSol.length > 1){
           // const idList = idSol.slice(0,idSol.length - 1)
           idSol.pop()
           window.localStorage.setItem("ids",JSON.stringify(idSol))
         }else {
           window.localStorage.removeItem("ids")
         }
         this.id = id
         this.$router.replace(`/index/customers/basicinfo/${id}/${this.category}`)
      }else {
         switch (parseInt(this.category)) {
           case 1:   //客户列表
             this.$router.replace({path: '/index/customer'})
             break
           case 2:  //客户池列表
             this.$router.replace({path: '/index/CustPool'})
             break
           default:
         }
      }
    },
    //初始化分页样式卡
    initPagStyle() {
      //初始化数据，选中对应显示路由
      const curveUrl = this.$route.path
      this.ziLuBy = this.ziLuBy.map((item) => {
        return {
          ...item, isOpt: curveUrl.includes(item.path) ? true : false
        }
      })
      this.id = this.$route.params.id
      this.category = this.$route.params.category
    }
  },
  watch: {
    $route: {
      handler(val, oldValue) {
        const from = val.path.split("/")
        from.pop()
        const to = oldValue.path.split("/")
        to.pop()
        const fromPath = from.join("/")
        const toPath = to.join("/")
        const formId = val.params.id
        const toId = oldValue.params.id
        if(!(fromPath == toPath)){
          this.initPagStyle()  //刷新一下样式
          if(!(formId == toId)){
            //记录id，用于回退
            const ids = window.localStorage.getItem("ids")
            if(ids){
              const idSol = JSON.parse(ids)
              window.localStorage.setItem("ids",JSON.stringify([...idSol,toId]))
            }else {
              window.localStorage.setItem("ids",JSON.stringify([toId]))
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  height: auto;
  padding: 0 calc(100vw * (20 / 1920));
}

.page-title {
  width: 100%;
  height: 3rem;
  display: flex;
  font-size: 0.9rem;
  letter-spacing: 2px;
  align-items: center;
}

.section-title {
  width: 100%;
  height: 3rem;
  background-color: white;
  border-radius: 5px;
  display: flex
}

.sinle-section {
  position: relative;
  width: auto;
  padding: 0.5rem 0;
  display: flex;
  font-size: 0.85rem;
  margin: 0 2rem 0 1rem;
  align-items: center;
}

.sinle-action {
  position: absolute;
  bottom: 0;
  left: calc(15%);
  height: calc(5px / 2);
  width: 70%;
  background-color: #0f86da;
}

.content-part {
  width: 100%;
  height: auto;
  margin-top: 0.8rem;
  padding: 1.5rem 0 0 0;
  background-color: white;
  text-align: left;
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/Customer/customerDetails.vue